/** Returns true only when data.locked is strictly boolean true. */
export function getNodeLocked(data: unknown): boolean {
  return (data !== null && typeof data === 'object' && (data as Record<string, unknown>).locked === true);
}
